export const BIOMARKERS = ["IL6", "IL8", "CRP", "SAA", "ICAM1"];